import { Link } from 'react-router-dom';
import { Button } from '../components/ui';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-8xl mb-6">👾</div>
        <h1 className="text-6xl font-bold text-purple-400 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Game Over</h2>
        <p className="text-slate-400 mb-8 max-w-md">
          The page you&apos;re looking for has gone to another castle. Maybe
          it&apos;s hiding behind some bricks?
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button size="lg">Return Home</Button>
          </Link>
          <Link to="/games">
            <Button variant="outline" size="lg">
              Browse Games
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
